import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginService } from '../shared/services/login.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  faTimesCircle = faTimesCircle;
  @ViewChild('alertModal', { static: false }) private alertModal;
  errorTitle: String;

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  })

  constructor(private loginService: LoginService, private router: Router, private modalService: NgbModal, private loadingBar: LoadingBarService) { }

  ngOnInit() {
  }

  loginUser() {
    if (!this.loginForm.invalid) {
      this.loginService.login(this.loginForm.value.username, this.loginForm.value.password)
        .subscribe(
          (x: { access_token: string, token_type: string, expires_in: number, refresh_token: string }) => {
            // console.log(x);
            localStorage.setItem('token', x.access_token)
            this.router.navigate(['/sava'])
          },
          (e) => {
            console.log(e);
            this.errorTitle = "Pogrešno korisničko ime ili lozinka";
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.errorTitle = "Korisničko ime ili lozinka nisu uneti";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }

}
